import React, { MouseEvent, useEffect, useState } from 'react';
import cn from 'classnames';
import { EmptyPanel, Button } from 'src/UI';
import { RdcGroupItemType, RdcGroupType } from '.';
import { RdcGroupItem } from './RdcGroupItem';
import st from "./GroupList.module.scss";
import classNames from 'classnames';

interface IRdcGroupProps extends React.HTMLAttributes<HTMLDivElement> {
	isLoading?: boolean;
	parentKey?: string;
	group: RdcGroupType;
	counted?: boolean;
	enableFavorite: boolean;
	selectedIdList: Array<string>;
	searchText: string;
	control: {
		isExpanded: boolean;
		toggle: () => void;
	};
	showMoreText: string;
	renderItemTb?: ( item: any ) => React.ReactNode;
	onGetParams: ( item: any ) => RdcGroupItemType;
	onAction: ( e: MouseEvent, item: any, action: string ) => void;
	renderItem?: ( item: RdcGroupItemType, parentItem: RdcGroupType ) => React.ReactNode;
	onMoreBtnClick: ( groupId: string, page: number  ) => void;
};

type SubGroupType = {
	title: string;
	list: Array<RdcGroupItemType>;
};

export const RdcGroup: React.FC<IRdcGroupProps> = ( props ) => {

	const { parentKey, isLoading = false, counted, group, control, 
		enableFavorite, selectedIdList, searchText, showMoreText,
		onMoreBtnClick, renderItem, onAction, onGetParams, renderItemTb 
	} = props;

	const [ groupedList, setGropedList ] = useState<SubGroupType[]>([]);

	useEffect( () => {
		const subGroups: SubGroupType[] = [];
		const groupWithoutSubHeader = group.list.filter( gr => !gr.subGroupTitle );

		if ( groupWithoutSubHeader.length === group.list.length ) {
			subGroups.push({ title: "", list: groupWithoutSubHeader });
		}
		else {
			group.list.forEach( gr => {
				const title = gr.subGroupTitle?.trim();

				if ( !title || subGroups.some( subGroup => subGroup.title === title ) ) return;

				const list = group.list.filter( g => g.subGroupTitle?.trim() === title );
				subGroups.push({ title, list });
			});
			subGroups.push({ title: "Не привязаны к паспорту услуги", list: groupWithoutSubHeader });
		}

		setGropedList( subGroups );
	}, [ group ] );

	const getTitle = ( item: RdcGroupType ) => item.groupTitle + ( counted ? ` ( ${item.count} )` : '' );

	const renderItemInner = ( item: RdcGroupItemType ) => {
		if ( !!renderItem ) 
			return renderItem(item, group );
		return (
			<RdcGroupItem
				enableFavorite={enableFavorite}
				selectedIdList={selectedIdList} 
				onGetParams={onGetParams}
				onAction={onAction}
				item={item}
				renderItemTb={renderItemTb}
				searchText={searchText}
			/>
		);
	};

	const renderGroupItem = ( item: RdcGroupItemType, index: number ) => (
		<div key={ parentKey + "_item" + index } className={classNames("group-item", st.rdcGroup__groupItems__item)}>
			{ renderItemInner(item) }
		</div>
	);

	const renderSubGroup = ( subGroup: SubGroupType, index: number ) => (
		<li key={ parentKey + "_sub" + index }>
			{ !!subGroup.title && <h5 className='headline-small' style={{ padding: '5px 0' }}>{ subGroup.title }</h5> }
			{ subGroup.list.map( renderGroupItem ) }
		</li>
	);

	const renderContent = () => (
		<ul className={st.rdcGroup__groupItems}>
			{ 
				!!group.list.length 
					? groupedList.map( renderSubGroup ) 
					: <EmptyPanel />
			}
			{
				group.count > group.list.length && 
				<li className={st.rdcGroup__morebtn}>
					<Button style={{ margin: '0 auto' }} outline bordered onClick={() => onMoreBtnClick( group.groupId, ++group.page )} isWait={isLoading}>
						{ showMoreText }
					</Button>
				</li>
			}
		</ul>
	);

	const title = getTitle( group );

	const renderHeader = () => (
		<div className={st.rdcGroup__item__header} onClick={control.toggle}>
			<h5 className={cn(st.rdcGroup__item__title, "headline-large")} title={title}>
				{ !!group.icon && group.icon }
				<span>{title}</span>
			</h5>
			<span className={st.rdcGroup__item__header__expand}>
				<svg width="32" height="32" viewBox="0 0 32 32" fill="none">
					<path d="M10.9026 20.2333L16.0026 15.1444L21.1026 20.2333L22.6693 18.6667L16.0026 12L9.33594 18.6667L10.9026 20.2333Z" fill="inherit"/>
				</svg>
			</span>
		</div>
	);
	
	if ( !group.list.length ) return null;

	return (
		<li className={cn(st.rdcGroup__item, { [st.expanded]: control.isExpanded })} >
			{ renderHeader() }
			{ control.isExpanded && renderContent() }
		</li>
	);
};
